export const DASHBOARD_QUERY_KEYS = {
  GET: ['schoolAdminDashboardData'] as const,
} as const
